let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hFmwG")).then(() => parcelRequire('1Sa6x'));